<div class="assigned-inspections-card">
  <div class="list-frame">
    <div class="header-controls-group">
      <div class="header-block">
        <h3>Assigned Inspections</h3>
        <p>Use dropdown menu to sort by inspector</p>
      </div>

      <div class="controls-row">
        <wm-common-dropdown
          class="inspector-field inspector-dropdown"
          [data]="inspectorDropdownData"
          (change)="onInspectorChange($event)"
        ></wm-common-dropdown>

        <div class="view-toggle">
          <button
            type="button"
            class="toggle-btn"
            [class.active]="viewMode === 'list'"
            (click)="setViewMode('list')"
          >
            List
          </button>
          <button
            type="button"
            class="toggle-btn"
            [class.active]="viewMode === 'map'"
            (click)="setViewMode('map')"
          >
            Map
          </button>
        </div>
      </div>
    </div>

    <ng-container>
      <div
        class="inspections-table-container"
        [style.display]="viewMode === 'list' ? '' : 'none'"
      >
        <wm-common-table
          class="assigned-list-table"
          [columns]="columns"
          [data]="data"
          [isLoading]="isLoading"
          [serverSidePagination]="true"
          [showRowsPerPage]="true"
          [currentPage]="currentPage"
          [totalPages]="totalPages"
          [pageSizeStorageKey]="'insections-assigned-janus'"
          [pageSize]="pageSize"
          (pageChange)="onPageChange($event)"
          (rowsPerPageChange)="onRowsPerPageChange($event)"
          tableType="Staff"
          expansionMode="inline"
          expandOn="cell"
          [expandedComponent]="expandedComponent"
          [expandedComponentInputs]="expandedComponentInputs"
          (sortChanged)="onSortChanged($event)"
          [sortField]="sortField"
          [sortDescending]="sortDescending"
        >
        </wm-common-table>
      </div>
    </ng-container>

    <div class="map-surface" *ngIf="viewMode === 'map'">
      <app-basic-esri-map
        [inputFilters]="mapFilters$"
        [initialFilters]="[]"
        [popupTemplateTitle]="'App #: {appNo}'"
        [popupTemplateContent]="
          'Inspection Type: {inspectionType}<br>Status: {status}<br>Inspector: {inspector}<br>Date: {inspectionDate}<br>Time: {inspectionTime}'
        "
        [popupActions]="mapPopupActions"
        (mapDataRequested)="onMapDataRequested($event)"
      >
      </app-basic-esri-map>
    </div>
  </div>

  <div
    class="assigned-list-pager-host"
    *ngIf="viewMode === 'list' && totalRecords > 0"
  >
    <wm-common-pagination
      class="common-table-pagination"
      [data]="paginationData"
      (pageSizeChange)="onRowsPerPageChange($event)"
      (pageSelect)="onPageChange($event)"
      (first)="goToFirstPage()"
      (previous)="goToPreviousPage()"
      (next)="goToNextPage()"
      (last)="goToLastPage()"
    >
    </wm-common-pagination>
  </div>

  <div
    class="assigned-map-pager-host"
    *ngIf="viewMode === 'map' && totalRecords > 0"
  >
    <wm-common-pagination
      class="common-table-pagination"
      [data]="paginationData"
      (pageSizeChange)="onRowsPerPageChange($event)"
      (pageSelect)="onPageChange($event)"
      (first)="goToFirstPage()"
      (previous)="goToPreviousPage()"
      (next)="goToNextPage()"
      (last)="goToLastPage()"
    >
    </wm-common-pagination>
  </div>
</div>

<ng-template #inspectionNoTemplate let-row>
  <div class="app-number-cell">
    <a
      [routerLink]="[]"
      [queryParams]="{ p: currentPage + 1, view: 'documents', id: row.id }"
      queryParamsHandling="merge"
      class="janus-anchor"
      (click)="onInspectionNumberClick($event, row)"
      >{{ row.inspectionAppNumber }}</a
    >
  </div>
</ng-template>
